<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端（原样不动） ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <!-- 搜索栏 -->
        <div class="search-bar">
          <el-input
            v-model="searchParams.name"
            placeholder="请输入组队充值房名称"
            clearable
            style="width: 220px; margin-right: 10px"
          ></el-input>

          <el-select
            v-model.number="searchParams.status"
            placeholder="请选择状态"
            clearable
            style="width: 180px; margin-right: 10px"
          >
            <el-option
              v-for="item in luckStatusList"
              :key="item.status"
              :label="item.desc"
              :value="item.status"
            />
          </el-select>

          <el-button type="primary" icon="el-icon-search" @click="getList"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
          <el-button type="success" icon="el-icon-plus" @click="handleAdd"
            >添加组队充值房</el-button
          >
        </div>

        <!-- 表格 -->
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handleRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="组队充值房图片" width="100" align="center">
            <template slot-scope="scope">
              <img
                :src="scope.row.image"
                style="
                  width: 50px;
                  height: 50px;
                  object-fit: cover;
                  border-radius: 4px;
                "
              />
            </template>
          </el-table-column>
          <el-table-column label="组队充值房名称" prop="name" min-width="200" />
          <el-table-column label="人数" prop="num" width="100" align="center" />
          <el-table-column
            label="状态名称"
            prop="status_desc"
            width="120"
            align="center"
            :key="1"
          />
          <el-table-column label="状态" width="180" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                active-text="上架"
                inactive-text="下架"
                @click.native.stop
                :disabled="scope.row.status == 2" 
                @change="handleSwitchChange(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            prop="created_at"
            width="180"
            align="center"
          />
          <el-table-column
            label="更新时间"
            prop="updated_at"
            width="180"
            align="center"
          />

          <el-table-column
            label="操作"
            width="400"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.stop="handleEdit(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                type="text"
                icon="el-icon-box"
                @click.stop="handleGoods(scope.row)"
              >
                赏品
              </el-button>
              <el-button
                type="text"
                icon="el-icon-tickets"
                @click.stop="handleLuckCode(scope.row)"
              >
                抽奖码
              </el-button>
              <el-button
                type="text"
                icon="el-icon-trophy"
                @click.stop="handleHitList(scope.row)"
              >
                中奖列表
              </el-button>
              <!-- 新增：删除按钮 -->
              <el-button
                type="text"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click.stop="handleDeleteLuck(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- 添加/编辑 弹窗 -->
        <el-dialog
          :title="form.room_id ? '编辑组队充值房' : '添加组队充值房'"
          :visible.sync="dialogVisible"
          width="600px"
          @close="resetForm"
          append-to-body
        >
          <el-form
            :model="form"
            :rules="addRules"
            ref="formRef"
            label-width="100px"
          >
            <el-form-item label="组队充值房名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入名称"
                clearable
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="组队充值房图片" prop="image">
              <el-button type="primary" @click="openImageDialog"
                >选择图片</el-button
              >
              <div v-if="form.image" style="margin-top: 10px">
                <img
                  :src="form.image"
                  style="width: 100px; height: 100px; object-fit: cover"
                />
              </div>
            </el-form-item>
            <el-form-item label="人数" prop="num">
              <el-input
                v-model.number="form.num"
                type="number"
                style="width: 320px"
              />
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button
              type="primary"
              @click="submitForm"
              :loading="submitLoading"
              >确认提交</el-button
            >
          </div>
        </el-dialog>

        <!-- 详情弹窗 -->
        <el-dialog
          title="组队充值房详情"
          :visible.sync="detailVisible"
          width="500px"
          append-to-body
        >
          <div v-if="detailData" class="detail-box">
            <p><label>ID：</label>{{ detailData.id }}</p>
            <p><label>名称：</label>{{ detailData.name }}</p>
            <p><label>图片：</label></p>
            <img
              :src="detailData.image"
              style="width: 120px; height: 120px; object-fit: cover"
            />
            <p>
              <label>状态：</label
              >{{ detailData.status == 1 ? "已上架" : "已下架" }}
            </p>
            <p><label>人数：</label>{{ detailData.num }}</p>
            <p><label>状态：</label>{{ detailData.status_desc }}</p>
          </div>
        </el-dialog>

        <!-- 组队充值房赏品弹窗 -->
        <el-dialog
          title="组队充值房赏品列表"
          :visible.sync="goodsVisible"
          width="1300px"
          append-to-body
        >
          <div v-loading="goodsLoading" style="min-height: 400px">
            <!-- 搜索条件置顶 -->
            <div
              style="
                display: flex;
                gap: 10px;
                margin-bottom: 15px;
                align-items: center;
              "
            >
              <el-select
                v-model="goodsSearch.level_id"
                placeholder="按等级筛选"
                clearable
                style="width: 160px"
              >
                <el-option
                  v-for="item in levelList"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getGoodsList"
                >搜索</el-button
              >
              <el-button icon="el-icon-refresh" @click="resetGoodsSearch"
                >重置</el-button
              >
              <el-button
                type="success"
                icon="el-icon-plus"
                @click="openGoodsSelect"
                >添加赏品</el-button
              >
            </div>

            <!-- 暂存表格 -->
            <div style="margin-bottom: 15px">
              <p style="font-weight: bold; margin-bottom: 8px">
                暂存待添加赏品
              </p>
              <el-table border :data="tempGoodsList" style="width: 100%">
                <el-table-column label="商品图片" width="100" align="center">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.image"
                      style="width: 50px; height: 50px; object-fit: cover"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品名称"
                  prop="title"
                  min-width="180"
                />
                <!-- 新增：赏品类型 -->
                <el-table-column label="赏品类型" width="110" align="center">
                  <template slot-scope="scope">
                    <span
                      :style="{
                        color:
                          scope.row.goods_type == 1 ? '#008000' : '#1890ff',
                      }"
                    >
                      {{ scope.row.goods_type == 1 ? "真实赏品" : "虚拟赏品" }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="等级" width="120" align="center">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.level_id" style="width: 100%">
                      <el-option
                        v-for="item in levelList"
                        :key="item.level_id"
                        :label="item.name"
                        :value="item.level_id"
                      />
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="价格" width="130" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model.number="scope.row.price"
                      type="number"
                      style="width: 100px"
                    />
                  </template>
                </el-table-column>

                <el-table-column label="兑换价格" width="130" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model.number="scope.row.recovery_price"
                      type="number"
                      style="width: 100px"
                    />
                  </template>
                </el-table-column>

                <el-table-column label="数量" width="100" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model.number="scope.row.num"
                      type="number"
                      style="width: 70px"
                    />
                  </template>
                </el-table-column>

                <el-table-column label="操作" width="100" align="center">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      @click="delTempGoods(scope.$index)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- 已保存赏品(数据库) -->
            <div style="margin-bottom: 15px">
              <p style="font-weight: bold; margin-bottom: 8px">
                已保存赏品(数据库)
              </p>
              <el-table border :data="goodsList" style="width: 100%">
                <el-table-column
                  label="ID"
                  prop="id"
                  width="70"
                  align="center"
                />
                <el-table-column label="商品图片" width="100" align="center">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.goods_image"
                      style="width: 50px; height: 50px; object-fit: cover"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品名称"
                  prop="goods_name"
                  min-width="120"
                />
                <!-- 新增：赏品类型 -->
                <el-table-column label="赏品类型" width="110" align="center">
                  <template slot-scope="scope">
                    <span
                      :style="{
                        color:
                          scope.row.goods_type == 1 ? '#008000' : '#1890ff',
                      }"
                    >
                      {{ scope.row.goods_type == 1 ? "真实赏品" : "虚拟赏品" }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="等级"
                  prop="level_name"
                  width="80"
                  align="center"
                />
                <el-table-column
                  label="总数量"
                  prop="origin_num"
                  width="80"
                  align="center"
                />
                <el-table-column
                  label="剩余数量"
                  prop="num"
                  width="80"
                  align="center"
                />
                <el-table-column
                  label="价格"
                  prop="price"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="兑换价格"
                  prop="recovery_price"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="创建时间"
                  prop="created_at"
                  width="180"
                  align="center"
                />
                <el-table-column
                  label="操作"
                  width="160"
                  fixed="right"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      icon="el-icon-edit"
                      @click.stop="handleEditBox(scope.row)"
                    >
                      编辑
                    </el-button>
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      style="color: #f56c6c"
                      @click.stop="handleDelBox(scope.row)"
                    >
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>

              <div style="text-align: right; margin-top: 15px">
                <el-pagination
                  @size-change="handleGoodsSizeChange"
                  @current-change="handleGoodsCurrentChange"
                  :current-page="goodsSearch.page"
                  :page-size="goodsSearch.page_size"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="goodsTotal"
                ></el-pagination>
              </div>
            </div>
          </div>

          <!-- 弹窗底部按钮：右下角 -->
          <div slot="footer" style="text-align: right">
            <el-button @click="goodsVisible = false">关闭</el-button>
            <el-button
              type="primary"
              @click="submitTempGoods"
              :disabled="tempGoodsList.length == 0"
            >
              确认提交全部暂存赏品
            </el-button>
          </div>
        </el-dialog>

        <!-- 选择赏品弹窗 -->
        <el-dialog
          title="选择赏品"
          :visible.sync="goodsSelectVisible"
          width="1300px"
          append-to-body
        >
          <div v-loading="goodsSelectLoading" style="min-height: 400px">
            <div
              style="
                display: flex;
                gap: 10px;
                margin-bottom: 15px;
                align-items: center;
              "
            >
              <el-input
                v-model="goodsSelectSearch.title"
                placeholder="商品名称"
                style="width: 200px"
                clearable
              />

              <el-select
                v-model="goodsSelectType"
                placeholder="商品类型"
                clearable
                style="width: 160px"
                @change="handleTypeChange"
              >
                <el-option
                  v-for="item in goodsLevelFirstList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>

              <el-select
                v-model="goodsSelectSearch.level_id"
                placeholder="等级筛选"
                clearable
                style="width: 160px"
              >
                <el-option
                  v-for="item in goodsLevelSecondList"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>

              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getGoodsSelectList"
                >搜索</el-button
              >
              <el-button icon="el-icon-refresh" @click="resetGoodsSelectSearch"
                >重置</el-button
              >
            </div>

            <el-table
              border
              :data="goodsSelectList"
              ref="goodsTableRef"
              @row-click="handleRowSelect"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55" align="center" />
              <el-table-column label="ID" prop="id" width="70" align="center" />
              <el-table-column label="商品图片" width="100" align="center">
                <template slot-scope="scope">
                  <img
                    :src="scope.row.image"
                    style="width: 50px; height: 50px; object-fit: cover"
                  />
                </template>
              </el-table-column>
              <el-table-column label="商品名称" prop="title" min-width="200" />
              <el-table-column label="商品类型" width="120" align="center">
                <template slot-scope="scope">
                  <span
                    :style="{
                      color: scope.row.goods_type == 1 ? '#008000' : '#1890ff',
                    }"
                  >
                    {{ scope.row.goods_type == 1 ? "真实赏品" : "虚拟赏品" }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="等级"
                prop="level_name"
                width="100"
                align="center"
              />
              <el-table-column
                label="价格"
                prop="price"
                width="100"
                align="center"
              />
            </el-table>

            <div style="text-align: right; margin-top: 15px">
              <el-pagination
                @size-change="handleGoodsSelectSizeChange"
                @current-change="handleGoodsSelectCurrentChange"
                :current-page="goodsSelectSearch.page"
                :page-size="goodsSelectSearch.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="goodsSelectTotal"
              ></el-pagination>
            </div>
          </div>

          <div slot="footer" style="text-align: right">
            <el-button @click="goodsSelectVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmSelectGoods"
              >确认选择</el-button
            >
          </div>
        </el-dialog>

        <!-- 图片选择弹窗 -->
        <el-dialog
          title="选择图片"
          :visible.sync="imageDialogVisible"
          width="1000px"
          append-to-body
        >
          <div style="display: flex; gap: 10px; margin-bottom: 15px">
            <el-input
              v-model="imageSearch.name"
              placeholder="名称"
              style="width: 220px"
              clearable
            />
            <el-select
              v-model.number="imageSearch.type"
              placeholder="类型"
              style="width: 200px"
              clearable
            >
              <el-option
                v-for="item in imageTypeList"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              />
            </el-select>
            <el-button type="primary" @click="getImageList">搜索</el-button>
            <el-button @click="resetImageSearch">重置</el-button>
          </div>

          <div
            v-loading="imageLoading"
            style="
              display: flex;
              flex-wrap: wrap;
              gap: 15px;
              max-height: 500px;
              overflow-y: auto;
            "
          >
            <div
              v-for="img in imageList"
              :key="img.id"
              style="
                cursor: pointer;
                border: 2px solid transparent;
                padding: 5px;
                border-radius: 6px;
              "
              :style="{
                borderColor:
                  selectedImageId == img.id ? '#409eff' : 'transparent', // 关键修复
              }"
              @click="selectImage(img)"
            >
              <img
                :src="img.url"
                style="width: 120px; height: 120px; object-fit: cover"
              />
            </div>
          </div>

          <div style="text-align: right; margin-top: 15px">
            <el-pagination
              @size-change="handleImageSizeChange"
              @current-change="handleImageCurrentChange"
              :current-page="imageSearch.page"
              :page-size="imageSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="imageTotal"
            ></el-pagination>
          </div>

          <div slot="footer">
            <el-button @click="imageDialogVisible = false">取消</el-button>
            <el-button type="success" @click="confirmSelectImage"
              >确认</el-button
            >
          </div>
        </el-dialog>

        <!-- 编辑赏品弹窗 -->
        <el-dialog
          title="编辑赏品"
          :visible.sync="editBoxVisible"
          width="500px"
          @close="resetEditBoxForm"
          append-to-body
        >
          <el-form :model="editBoxForm" label-width="100px" ref="editBoxRef">
            <el-form-item label="商品图片">
              <img
                :src="editBoxForm.goods_image"
                style="width: 80px; height: 80px; object-fit: cover"
              />
            </el-form-item>
            <el-form-item label="商品名称">
              <span>{{ editBoxForm.goods_name }}</span>
            </el-form-item>

            <el-form-item label="等级" prop="level_id">
              <el-select
                v-model.number="editBoxForm.level_id"
                style="width: 320px"
              >
                <el-option
                  v-for="item in levelList"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="价格" prop="price">
              <el-input
                v-model.number="editBoxForm.price"
                type="number"
                style="width: 320px"
              />
            </el-form-item>

            <el-form-item label="兑换价格" prop="recovery_price">
              <el-input
                v-model.number="editBoxForm.recovery_price"
                type="number"
                style="width: 320px"
              />
            </el-form-item>

            <el-form-item label="总数量" prop="origin_num">
              <el-input
                v-model.number="editBoxForm.origin_num"
                type="number"
                style="width: 320px"
              />
            </el-form-item>
          </el-form>

          <div slot="footer">
            <el-button @click="editBoxVisible = false">取消</el-button>
            <el-button
              type="primary"
              @click="submitEditBox"
              :loading="editBoxLoading"
            >
              确认保存
            </el-button>
          </div>
        </el-dialog>

        <!-- 抽奖码列表弹窗 -->
        <el-dialog
          title="抽奖码列表"
          :visible.sync="luckCodeVisible"
          width="1200px"
          append-to-body
        >
          <!-- 筛选栏 -->
          <div
            style="
              display: flex;
              gap: 10px;
              margin-bottom: 15px;
              align-items: center;
            "
          >
            <el-input
              v-model="codeSearch.code"
              placeholder="请输入抽奖码"
              clearable
              style="width: 240px"
            ></el-input>

            <el-select
              v-model.number="codeSearch.status"
              placeholder="使用状态"
              clearable
              style="width: 150px"
            >
              <el-option label="未使用" :value="0"></el-option>
              <el-option label="已使用" :value="1"></el-option>
            </el-select>

            <el-select
              v-model.number="codeSearch.is_draw"
              placeholder="中奖状态"
              clearable
              style="width: 150px"
            >
              <el-option label="未中奖" :value="0"></el-option>
              <el-option label="已中奖" :value="1"></el-option>
            </el-select>

            <el-button type="primary" icon="el-icon-search" @click="getCodeList"
              >搜索</el-button
            >
            <el-button icon="el-icon-refresh" @click="resetCodeSearch"
              >重置</el-button
            >
          </div>

          <div v-loading="codeLoading" style="min-height: 400px">
            <el-table border :data="codeList" style="width: 100%">
              <el-table-column label="ID" prop="id" width="80" align="center" />
              <el-table-column label="抽奖码" prop="code" min-width="220" />
              <el-table-column
                label="用户ID"
                prop="user_id"
                width="100"
                align="center"
              />

              <!-- <el-table-column
                label="头像"
                width="80"
                align="center"
                v-if="checkedColumns.includes('avatar')"
              >
                <template slot-scope="scope">
                  <img
                    :src="scope.row.avatar"
                    style="
                      width: 50px;
                      height: 50px;
                      object-fit: cover;
                      border-radius: 4px;
                    "
                    alt="头像"
                  />
                </template>
              </el-table-column> -->

              <el-table-column
                label="用户名"
                prop="username"
                width="120"
                align="center"
              />
              <el-table-column
                label="使用状态"
                prop="status_desc"
                width="100"
                align="center"
              />
              <el-table-column
                label="中奖状态"
                prop="is_draw_desc"
                width="100"
                align="center"
              />
              <el-table-column
                label="sys_prize_id"
                prop="sys_prize_id"
                width="100"
                align="center"
              />
              <el-table-column
                label="奖品名称"
                prop="goods_name"
                min-width="180"
              />
              <el-table-column
                label="创建时间"
                prop="created_at"
                width="180"
                align="center"
              />
              <!-- 新增：编辑赏品 -->
              <el-table-column
                label="操作"
                width="100"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.status == 1"
                    type="text"
                    icon="el-icon-edit"
                    @click.stop="openCodePrizeDialog(scope.row)"
                  >
                    编辑
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <div style="text-align: right; margin-top: 15px">
              <el-pagination
                @size-change="handleCodeSizeChange"
                @current-change="handleCodeCurrentChange"
                :current-page="codeSearch.page"
                :page-size="codeSearch.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="codeTotal"
              ></el-pagination>
            </div>
          </div>

          <div slot="footer" style="text-align: right">
            <el-button @click="luckCodeVisible = false">关闭</el-button>
          </div>

          <!-- ====================== 抽奖码编辑赏品弹窗 ====================== -->
          <el-dialog
            title="选择该抽奖码的赏品"
            :visible.sync="codePrizeVisible"
            width="850px"
            append-to-body
          >
            <div v-loading="codeLoading" style="min-height: 300px">
              <el-table
                border
                :data="codePrizeList"
                ref="codePrizeTableRef"
                style="width: 100%"
                highlight-current-row
                @row-click="handleSelectCodePrize"
              >
                <!-- 稳定单选列 -->
                <el-table-column label="选择" width="80" align="center">
                  <template slot-scope="scope">
                    <el-radio
                      :label="scope.row.uuid"
                      v-model="selectedPrizeId"
                      @change="() => handleSelectCodePrize(scope.row)"
                    >
                    </el-radio>
                  </template>
                </el-table-column>

                <el-table-column
                  label="赏品ID"
                  prop="id"
                  width="80"
                  align="center"
                />
                <el-table-column label="商品图片" width="100" align="center">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.goods_image"
                      style="width: 50px; height: 50px; object-fit: cover"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品名称"
                  prop="goods_name"
                  min-width="180"
                />
                <el-table-column
                  label="等级"
                  prop="level_id"
                  width="80"
                  align="center"
                />
                <el-table-column
                  label="价格"
                  prop="price"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="兑换价格"
                  prop="recovery_price"
                  width="120"
                  align="center"
                />
              </el-table>
            </div>

            <div slot="footer" style="text-align: right">
              <el-button @click="codePrizeVisible = false">取消</el-button>
              <el-button type="primary" @click="confirmCodePrize"
                >确认选择</el-button
              >
            </div>
          </el-dialog>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端（全新重写 + 独立抽奖码） ====================== -->
    <div class="mobile-version">
      <!-- ====================== 移动端抽奖码编辑赏品弹窗 ====================== -->
      <el-dialog
        title="选择中奖赏品"
        :visible.sync="mobileCodePrizeVisible"
        width="95%"
        top="10vh"
        custom-class="mobile-dialog"
        append-to-body
      >
        <div
          v-loading="codePrizeLoadingMobile"
          style="padding: 10px 0; min-height: 300px"
        >
          <div class="mobile-prize-list">
            <div
              class="prize-item"
              v-for="item in codePrizeListMobile"
              :key="item.uuid"
              :class="{ active: selectedPrizeId == item.uuid }"
              @click="selectMobilePrize(item)"
            >
              <el-radio
                :label="item.uuid"
                v-model="selectedPrizeId"
                @change="() => selectMobilePrize(item)"
              />
              <img :src="item.goods_image" class="prize-img" />
              <div class="prize-info">
                <div class="name">{{ item.goods_name }}</div>
                <div class="level">等级：{{ item.level_id }}</div>
                <div class="price">¥{{ item.price }}</div>
              </div>
            </div>

            <div
              class="empty"
              v-if="codePrizeListMobile.length == 0 && !codePrizeLoadingMobile"
            >
              暂无可用赏品
            </div>
          </div>
        </div>

        <div slot="footer" style="text-align: right">
          <el-button @click="mobileCodePrizeVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmMobileCodePrize"
            >确认保存</el-button
          >
        </div>
      </el-dialog>
      <!-- ====================== 移动端中奖列表弹窗 ====================== -->
      <el-dialog
        title="中奖记录"
        :visible.sync="mobileHitVisible"
        width="95%"
        top="8vh"
        custom-class="mobile-dialog mobile-hit-dialog"
        append-to-body
      >
        <div class="mobile-hit-search">
          <el-input
            v-model="hitSearchMobile.user_id"
            placeholder="用户ID"
            clearable
            size="small"
            prefix-icon="el-icon-search"
          ></el-input>
          <div class="search-btn-row" style="margin-top: 8px">
            <el-button
              type="primary"
              plain
              size="small"
              @click="getMobileHitList"
              style="flex: 1"
            >
              搜索
            </el-button>
            <el-button
              plain
              size="small"
              @click="resetMobileHitSearch"
              style="flex: 1"
            >
              重置
            </el-button>
          </div>
        </div>

        <div class="mobile-hit-card-list" v-loading="hitLoadingMobile">
          <div class="hit-card" v-for="item in hitListMobile" :key="item.id">
            <div class="hit-top">
              <div class="hit-user">
                <img :src="item.avatar" class="avatar" alt="头像" />
                <div class="info">
                  <div class="nickname">{{ item.nickname || "匿名用户" }}</div>
                  <div class="uid">ID:{{ item.user_id }}</div>
                </div>
              </div>
              <div class="hit-code">{{ item.code }}</div>
            </div>

            <div class="hit-goods">
              <img :src="item.goods_image" class="goods-img" alt="奖品" />
              <div class="goods-info">
                <div class="goods-name">
                  {{ item.goods_name || "未知奖品" }}
                </div>
                <div class="price">兑换价：¥{{ item.recovery_price }}</div>
              </div>
            </div>

            <div class="hit-time">
              <div>抽奖时间：{{ item.cy_at || "---" }}</div>
              <div>创建时间：{{ item.created_at }}</div>
            </div>
          </div>

          <div
            class="empty"
            v-if="hitListMobile.length == 0 && !hitLoadingMobile"
          >
            暂无中奖记录
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleMobileHitSizeChange"
            @current-change="handleMobileHitCurrentChange"
            :current-page="hitSearchMobile.page"
            :page-size="hitSearchMobile.page_size"
            layout="total, prev, pager, next, jumper"
            :total="hitTotalMobile"
            small
          />
        </div>

        <div slot="footer" style="text-align: right">
          <el-button @click="mobileHitVisible = false">关闭</el-button>
        </div>
      </el-dialog>
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 搜索栏 -->
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.name"
            placeholder="组队充值房名称"
            clearable
            size="medium"
            prefix-icon="el-icon-search"
          />
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-select
              v-model.number="searchParams.status"
              placeholder="状态"
              clearable
              size="medium"
              style="flex: 1"
            >
              <el-option
                v-for="item in luckStatusList"
                :key="item.status"
                :label="item.desc"
                :value="item.status"
              />
            </el-select>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
            >
              搜索
            </el-button>
            <el-button plain round @click="resetSearch" style="flex: 1">
              重置
            </el-button>
          </div>
        </div>

        <!-- 卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="openMobileDetail(item)"
          >
            <div class="card-header">
              <img :src="item.image" class="card-img" alt="" />
              <div class="info">
                <div class="title">{{ item.name }}</div>
                <div class="meta">ID:{{ item.id }} | 人数:{{ item.num }}</div>
              </div>
              <div class="status-wrap">
                <div class="status" :class="getStatusClass(item.status)">
                  {{ getStatusText(item.status) }}
                </div>
                <el-switch
                  v-model="item.status"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="上架"
                  inactive-text="下架"
                  :disabled="item.status == 2"
                  @click.native.stop
                  @change="handleMobileSwitchChange(item)"
                />
              </div>
            </div>
            <div class="card-body">
              <div>状态：{{ item.status_desc }}</div>
              <div>创建：{{ item.created_at }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="info"
                round
                @click.stop="openMobileLuckCode(item)"
                style="margin-left: 8px"
              >
                抽奖码
              </el-button>
              <el-button
                size="mini"
                type="success"
                round
                @click.stop="openMobileHitList(item)"
              >
                中奖
              </el-button>
              <el-button
                size="mini"
                type="danger"
                round
                @click.stop="handleMobileDel(item)"
                style="margin-left: 8px"
              >
                删除
              </el-button>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageTotal"
            pager-count="2"
            small
          />
        </div>

        <!-- ====================== 移动端详情弹窗 ====================== -->
        <el-dialog
          title="组队充值房详情"
          :visible.sync="mobileDetailVisible"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div v-if="mobileDetailRow" style="padding: 10px">
            <div style="text-align: center; margin-bottom: 10px">
              <img
                :src="mobileDetailRow.image"
                style="
                  width: 100px;
                  height: 100px;
                  object-fit: cover;
                  border-radius: 8px;
                "
              />
            </div>
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item label="ID">{{
                mobileDetailRow.id
              }}</el-descriptions-item>
              <el-descriptions-item label="名称">{{
                mobileDetailRow.name
              }}</el-descriptions-item>
              <el-descriptions-item label="人数">{{
                mobileDetailRow.num
              }}</el-descriptions-item>
              <el-descriptions-item label="状态">
                <span :style="getStatusStyle(mobileDetailRow.status)">
                  {{ getStatusText(mobileDetailRow.status) }}
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="状态文本">{{
                mobileDetailRow.status_desc
              }}</el-descriptions-item>
              <el-descriptions-item label="创建时间">{{
                mobileDetailRow.created_at
              }}</el-descriptions-item>
              <el-descriptions-item label="更新时间">{{
                mobileDetailRow.updated_at
              }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button @click="mobileDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- ====================== 移动端编辑弹窗 ====================== -->
        <el-dialog
          title="编辑组队充值房"
          :visible.sync="mobileEditVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileEditForm"
            :rules="addRules"
            ref="mobileEditRef"
            label-width="90px"
            size="small"
          >
            <el-form-item label="名称" prop="name">
              <el-input
                v-model="mobileEditForm.name"
                placeholder="名称"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="图片">
              <el-button type="primary" size="medium" @click="openImageDialog">
                选择图片
              </el-button>
              <div v-if="mobileEditForm.image" style="margin-top: 10px">
                <img
                  :src="mobileEditForm.image"
                  style="width: 80px; height: 80px; object-fit: cover"
                />
              </div>
            </el-form-item>
            <el-form-item label="人数" prop="num">
              <el-input
                v-model.number="mobileEditForm.num"
                placeholder="人数"
                size="medium"
              />
            </el-form-item>
          </el-form>

          <div
            slot="footer"
            style="
              text-align: right;
              display: flex;
              justify-content: flex-end;
              gap: 10px;
            "
          >
            <el-button size="medium" @click="mobileEditVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="submitMobileEdit"
              >保存</el-button
            >
          </div>
        </el-dialog>

        <!-- ====================== 移动端独立抽奖码弹窗（带复制） ====================== -->
        <el-dialog
          title="我的抽奖码"
          :visible.sync="mobileLuckCodeVisible"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog mobile-code-dialog"
          append-to-body
        >
          <div class="mobile-code-search">
            <el-input
              v-model="codeSearchMobile.code"
              placeholder="输入抽奖码"
              clearable
              size="small"
              prefix-icon="el-icon-search"
            ></el-input>
            <div class="search-row">
              <el-select
                v-model.number="codeSearchMobile.status"
                placeholder="使用状态"
                clearable
                size="small"
              >
                <el-option label="未使用" :value="0"></el-option>
                <el-option label="已使用" :value="1"></el-option>
              </el-select>
              <el-select
                v-model.number="codeSearchMobile.is_draw"
                placeholder="中奖状态"
                clearable
                size="small"
              >
                <el-option label="未中奖" :value="0"></el-option>
                <el-option label="已中奖" :value="1"></el-option>
              </el-select>
            </div>
            <div class="search-btn-row">
              <el-button
                type="primary"
                plain
                size="small"
                @click="getMobileCodeList"
                style="flex: 1"
                >搜索</el-button
              >
              <el-button
                plain
                size="small"
                @click="resetMobileCodeSearch"
                style="flex: 1"
                >重置</el-button
              >
            </div>
          </div>

          <div class="mobile-code-card-list" v-loading="codeLoadingMobile">
            <div
              class="code-card"
              v-for="item in codeListMobile"
              :key="item.id"
            >
              <div class="code-top">
                <div
                  class="code-number"
                  :class="{ used: item.status == 1, draw: item.is_draw == 1 }"
                >
                  {{ item.code }}
                </div>
                <div class="code-badges">
                  <span
                    class="badge"
                    :class="item.status == 1 ? 'badge-used' : 'badge-unuse'"
                  >
                    {{ item.status_desc }}
                  </span>
                  <span
                    class="badge"
                    :class="item.is_draw == 1 ? 'badge-draw' : 'badge-nodraw'"
                  >
                    {{ item.is_draw_desc }}
                  </span>
                </div>
              </div>
              <div class="code-info">
                <div>用户：{{ item.username || "未领取" }}</div>
                <div>奖品：{{ item.goods_name || "无" }}</div>
                <div>时间：{{ item.created_at }}</div>
              </div>
              <div class="code-copy-btn" @click="copyLuckCode(item.code)">
                <i class="el-icon-document-copy"></i> 点击复制
              </div>
              <!-- 新增：编辑赏品按钮 -->
              <div
                class="code-edit-btn"
                @click.stop="openMobileCodePrize(item)"
                v-if="item.status == 1"
              >
                <i class="el-icon-edit"></i> 编辑赏品
              </div>
            </div>
            <div
              class="empty"
              v-if="codeListMobile.length == 0 && !codeLoadingMobile"
            >
              暂无抽奖码
            </div>
          </div>

          <div style="text-align: center; margin-top: 15px">
            <el-pagination
              @size-change="handleMobileCodeSizeChange"
              @current-change="handleMobileCodeCurrentChange"
              :current-page="codeSearchMobile.page"
              :page-size="codeSearchMobile.page_size"
              layout="total, prev, pager, next, jumper"
              :total="codeTotalMobile"
              
            pager-count="2"
            small
            />
          </div>

          <div slot="footer" style="text-align: right">
            <el-button @click="mobileLuckCodeVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- 中奖列表弹窗 -->
        <el-dialog
          title="中奖列表"
          :visible.sync="hitVisible"
          width="1200px"
          append-to-body
        >
          <div v-loading="hitLoading" style="min-height: 400px">
            <el-table border :data="hitList" style="width: 100%">
              <el-table-column label="ID" prop="id" width="80" align="center" />
              <el-table-column
                label="用户ID"
                prop="user_id"
                width="100"
                align="center"
              />
              <el-table-column
                label="用户昵称"
                prop="nickname"
                width="120"
                align="center"
              />
              <el-table-column label="头像" width="80" align="center">
                <template slot-scope="scope">
                  <img
                    :src="scope.row.avatar"
                    style="
                      width: 40px;
                      height: 40px;
                      border-radius: 50%;
                      object-fit: cover;
                    "
                  />
                </template>
              </el-table-column>
              <el-table-column label="抽奖码" prop="code" min-width="220" />
              <el-table-column
                label="奖品名称"
                prop="goods_name"
                min-width="180"
              />
              <el-table-column label="奖品图片" width="100" align="center">
                <template slot-scope="scope">
                  <img
                    :src="scope.row.goods_image"
                    style="width: 50px; height: 50px; object-fit: cover"
                  />
                </template>
              </el-table-column>
              <el-table-column
                label="兑换价格"
                prop="recovery_price"
                width="100"
                align="center"
              />
              <el-table-column
                label="抽奖时间"
                prop="cy_at"
                width="180"
                align="center"
              />
              <el-table-column
                label="创建时间"
                prop="created_at"
                width="180"
                align="center"
              />
            </el-table>

            <div style="text-align: right; margin-top: 15px">
              <el-pagination
                @size-change="handleHitSizeChange"
                @current-change="handleHitCurrentChange"
                :current-page="hitSearch.page"
                :page-size="hitSearch.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="hitTotal"
            pager-count="2"
            small
              ></el-pagination>
            </div>
          </div>

          <div slot="footer" style="text-align: right">
            <el-button @click="hitVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "LuckRooms",
  data() {
    return {
      // 移动端弹窗
      mobileDetailVisible: false,
      mobileDetailRow: null,
      mobileEditVisible: false,
      mobileEditForm: {
        room_id: "",
        name: "",
        image: "",
        num: "",
      },

      // 移动端独立抽奖码
      mobileLuckCodeVisible: false,
      codeListMobile: [],
      codeTotalMobile: 0,
      codeLoadingMobile: false,
      codeSearchMobile: {
        page: 1,
        page_size: 10,
        room_id: "",
        code: "",
        status: "",
        is_draw: "",
      },

      // 赏品编辑弹窗
      editBoxVisible: false,
      editBoxLoading: false,
      editBoxForm: {
        prize_id: "",
        goods_id: "",
        goods_name: "",
        goods_image: "",
        level_id: "",
        price: "",
        recovery_price: "",
        origin_num: "",
      },
      loading: false,
      tableData: [],
      pageTotal: 0,
      luckStatusList: [],
      levelList: [],
      searchParams: {
        page: 1,
        page_size: 10,
        name: "",
        status: "",
      },
      // 抽奖码
      luckCodeVisible: false,
      codeLoading: false,
      codeList: [],
      codeTotal: 0,
      codeSearch: {
        page: 1,
        page_size: 10,
        room_id: "",
        code: "", // 抽奖码
        status: "", // 使用状态 0未使用 1已使用
        is_draw: "", // 中奖状态 0未中奖 1已中奖
      },
      dialogVisible: false,
      submitLoading: false,
      form: { room_id: "", name: "", image: "", num: "" },
      addRules: {
        name: [{ required: true, message: "请输入名称" }],
        image: [{ required: true, message: "请选择图片" }],
        num: [{ required: true, message: "请输入人数" }],
      },

      detailVisible: false,
      detailData: null,

      // 赏品弹窗
      goodsVisible: false,
      goodsLoading: false,
      currentLuck: null,
      goodsList: [],
      goodsTotal: 0,
      goodsSearch: { page: 1, page_size: 15, room_id: "", level_id: "" },

      // 选择赏品弹窗
      goodsSelectVisible: false,
      goodsSelectLoading: false,
      goodsSelectList: [],
      goodsSelectTotal: 0,
      goodsLevelFirstList: [],
      goodsLevelSecondList: [],
      goodsSelectType: "",
      goodsSelectSearch: {
        page: 1,
        page_size: 10,
        title: "",
        type: "",
        level_id: "",
        flag: 11,
      },
      selectedGoodsList: [],

      // 暂存表格
      tempGoodsList: [],

      // 图片
      imageDialogVisible: false,
      imageLoading: false,
      imageList: [],
      imageTotal: 0,
      imageSearch: { page: 1, page_size: 12, name: "", type: "" },
      imageTypeList: [],
      selectedImageId: "",
      selectedImageUrl: "",

      // 中奖列表
      hitVisible: false,
      hitLoading: false,
      hitList: [],
      hitTotal: 0,
      hitSearch: {
        page: 1,
        page_size: 10,
        room_id: "",
        user_id: "",
      },
      // 抽奖码编辑赏品弹窗
      codePrizeVisible: false,
      codePrizeList: [],
      selectedCodePrize: null,
      currentCodeId: "",
      selectedPrizeId: null, // 单选选中的赏品 ID
      // 移动端中奖列表
      mobileHitVisible: false,
      hitListMobile: [],
      hitTotalMobile: 0,
      hitLoadingMobile: false,
      hitSearchMobile: {
        page: 1,
        page_size: 10,
        room_id: "",
        user_id: "",
      },

      // 移动端抽奖码编辑赏品
      mobileCodePrizeVisible: false,
      codePrizeLoadingMobile: false,
      codePrizeListMobile: [],
      currentCodeIdMobile: "",
      selectedPrizeId: null,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 移动端详情
    openMobileDetail(row) {
      this.mobileDetailRow = JSON.parse(JSON.stringify(row));
      this.mobileDetailVisible = true;
    },

    // 移动端编辑
    openMobileEdit(id) {
      let row = this.tableData.find((item) => item.id == id);
      if (!row) return;
      this.mobileEditVisible = true;
      this.mobileEditForm = {
        room_id: row.id,
        name: row.name || "",
        image: row.image || "",
        num: row.num || "",
      };
    },

    // 移动端提交编辑
    async submitMobileEdit() {
      this.loading = true;
      try {
        const res = await api.rechargeWealRoom.edit(this.mobileEditForm);
        if (res.data.code == 1000) {
          this.mobileEditVisible = false;
          this.getList();
        }
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },

    // 移动端删除
    handleMobileDel(row) {
      this.$confirm("确定删除该组队充值房？删除后不可恢复", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api.rechargeWealRoom.del({ room_id: row.id }).then((res) => {
            if (res.data.code == 1000) this.getList();
          });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },

    // 打开移动端独立抽奖码
    openMobileLuckCode(row) {
      this.codeSearchMobile.room_id = row.id;
      this.resetMobileCodeSearch();
    },
    async getMobileCodeList() {
      this.codeLoadingMobile = true;
      const res = await api.rechargeWealRoom.codeList({ params: this.codeSearchMobile });
      if (res.data.code == 1000) {
        this.codeListMobile = res.data.data.data || [];
        this.codeTotalMobile = res.data.data.total || 0;
      }
      this.codeLoadingMobile = false;
      this.mobileLuckCodeVisible = true;
    },
    resetMobileCodeSearch() {
      this.codeSearchMobile = {
        page: 1,
        page_size: 10,
        room_id: this.codeSearchMobile.room_id,
        code: "",
        status: "",
        is_draw: "",
      };
      this.getMobileCodeList();
    },
    // 复制抽奖码
    copyLuckCode(code) {
      if (!code) return;
      let input = document.createElement("input");
      input.value = code;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message.success("复制成功：" + code);
    },
    handleMobileCodeSizeChange(val) {
      this.codeSearchMobile.page_size = val;
      this.getMobileCodeList();
    },
    handleMobileCodeCurrentChange(val) {
      this.codeSearchMobile.page = val;
      this.getMobileCodeList();
    },
    // 编辑赏品
    handleEditBox(row) {
      this.editBoxForm = {
        prize_id: row.id,
        goods_id: row.goods_id,
        goods_name: row.goods_name,
        goods_image: row.goods_image,
        level_id: row.level_id,
        goods_type: row.goods_type,
        price: Number(row.price),
        recovery_price: Number(row.recovery_price),
        origin_num: Number(row.origin_num),
      };
      this.editBoxVisible = true;
    },
    // 状态文字
    getStatusText(s) {
      if (s == 1) return "上架";
      if (s == 0) return "下架";
      return "已结束";
    },
    getStatusClass(s) {
      return s == 1 ? "on" : s == 0 ? "waiting" : "off";
    },
    getStatusStyle(s) {
      return s == 1
        ? "color:#409EFF"
        : s == 0
        ? "color:#909399"
        : "color:#f56c6c";
    },

    // 删除组队充值房
    async handleDeleteLuck(row) {
      this.$confirm(`确定要删除组队充值房${row.name}吗？删除后不可恢复！`, "提示", {
        confirmButtonText: "确定删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // 只有点确定才会进这里
          const res = await api.rechargeWealRoom.del({ room_id: row.id });
          if (res.data.code == 1000) {
            this.getList();
          } else {
          }
        })
        .catch(() => {
          // 点取消走这里
          this.$message.info("已取消删除");
        });
    },
    // 打开图片选择弹窗
    openImageDialog() {
      // 重置选中
      this.selectedImageId = "";
      this.selectedImageUrl = "";

      // 打开弹窗 + 请求图片列表
      this.imageDialogVisible = true;
      this.getImageList();
    },
    // 开关切换上架/下架
    async handleSwitchChange(row) {
      const oldStatus = row.status == 1 ? 0 : 1;
      const newStatus = row.status;

      try {
        const res = await api.rechargeWealRoom.status({
          room_id: row.id,
          status: newStatus,
        });

        if (res.data.code == 1000) {
          this.getList();
        } else {
          // 接口失败，回滚开关
          row.status = oldStatus;
        }
      } catch (err) {
        // 请求异常，回滚开关
        row.status = oldStatus;
      }
    },
    async getList() {
      this.loading = true;
      const res = await api.rechargeWealRoom.index({ params: this.searchParams });
      if (res.data.code == 1000) {
        this.tableData = res.data.data.data || [];
        this.luckStatusList = res.data.data.luck_status || [];
        this.levelList = res.data.data.level || [];
        this.pageTotal = res.data.data.total || 0;
      }
      this.loading = false;
    },

    handleAdd() {
      this.resetForm();
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.form = { ...row };
      this.dialogVisible = true;
    },
    async submitForm() {
      try {
        // 先校验表单
        await this.$refs.formRef.validate();
        this.submitLoading = true;

        // 判断是新增还是编辑
        let res;
        if (this.form.room_id) {
          // 编辑：有 ID，调用 edit
          res = await api.rechargeWealRoom.edit(this.form);
        } else {
          // 新增：无 ID，调用 add
          res = await api.rechargeWealRoom.add(this.form);
        }

        if (res.data.code == 1000) {
          this.dialogVisible = false;
          this.getList(); // 刷新列表
        } else {
        }
      } catch (err) {
        console.error("提交失败", err);
      } finally {
        this.submitLoading = false;
      }
    },
    // 打开抽奖码列表
    handleLuckCode(row) {
      this.resetCodeSearch(); // 打开先重置
      this.codeSearch.room_id = row.id;
      this.getCodeList();
      this.luckCodeVisible = true;
    },

    // 获取抽奖码列表
    async getCodeList() {
      this.codeLoading = true;
      const res = await api.rechargeWealRoom.codeList({ params: this.codeSearch });
      if (res.data.code == 1000) {
        this.codeList = res.data.data.data || [];
        this.codeTotal = res.data.data.total || 0;
      }
      this.codeLoading = false;
    },

    // 重置抽奖码筛选
    resetCodeSearch() {
      this.codeSearch = {
        page: 1,
        page_size: 10,
        room_id: this.codeSearch.room_id, // 保留当前组队充值房ID
        code: "",
        status: "",
        is_draw: "",
      };
      this.getCodeList();
    },

    // 抽奖码分页
    handleCodeSizeChange(val) {
      this.codeSearch.page_size = val;
      this.getCodeList();
    },
    handleCodeCurrentChange(val) {
      this.codeSearch.page = val;
      this.getCodeList();
    },
    // 编辑赏品
    handleEdit(row) {
      this.form = {
        room_id: row.id, // 强制将 row.id 赋值给 form.room_id
        name: row.name,
        image: row.image,
        num: row.num,
      };
      this.dialogVisible = true;
    },

    // 提交编辑赏品
    async submitEditBox() {
      this.editBoxLoading = true;
      const res = await api.rechargeWealRoom.editBoxPrize(this.editBoxForm);
      if (res.data.code == 1000) {
        this.editBoxVisible = false;
        this.getGoodsList();
      }
      this.editBoxLoading = false;
    },

    // 删除赏品
    async handleDelBox(row) {
      await this.$confirm("确定要删除该赏品吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch(() => {
        return Promise.reject("取消删除");
      });

      const res = await api.rechargeWealRoom.delBoxPrize({ prize_id: row.id });
      if (res.data.code == 1000) {
        this.getGoodsList();
      }
    },

    // 重置编辑表单
    resetEditBoxForm() {
      this.editBoxForm = {
        prize_id: "",
        goods_id: "",
        goods_name: "",
        goods_image: "",
        level_id: "",
        price: "",
        recovery_price: "",
        origin_num: "",
      };
    },
    handleGoods(row) {
      // 切换组队充值房 → 清空暂存
      if (this.currentLuck && this.currentLuck.id != row.id) {
        this.tempGoodsList = [];
      }
      this.currentLuck = row;
      this.goodsSearch.room_id = row.id;
      this.getGoodsList();
      this.goodsVisible = true;
    },

    async getGoodsList() {
      this.goodsLoading = true;
      const res = await api.rechargeWealRoom.boxList({ params: this.goodsSearch });
      if (res.data.code == 1000) {
        this.goodsList = res.data.data.data || [];
        this.goodsTotal = res.data.data.total || 0;
      }
      this.goodsLoading = false;
    },
    resetGoodsSearch() {
      this.goodsSearch = {
        page: 1,
        page_size: 10,
        room_id: this.currentLuck ? this.currentLuck.id : "",
        level_id: "",
      };
      this.getGoodsList();
    },

    // 打开选择赏品 → 自动勾选暂存数据
    async openGoodsSelect() {
      this.resetGoodsSelectSearch();
      await this.getGoodsSelectList();
      // 自动勾选暂存里的商品
      this.$nextTick(() => {
        if (this.tempGoodsList.length > 0) {
          this.goodsSelectList.forEach((row) => {
            const exist = this.tempGoodsList.some((item) => item.id == row.id);
            if (exist) {
              this.$refs.goodsTableRef.toggleRowSelection(row, true);
            }
          });
        }
      });
      this.goodsSelectVisible = true;
    },

    async getGoodsSelectList() {
      this.goodsSelectSearch.type = this.goodsSelectType;
      this.goodsSelectLoading = true;
      const res = await api.goods.index({ params: this.goodsSelectSearch });
      if (res.data.code == 1000) {
        this.goodsSelectList = res.data.data.data || [];
        this.goodsSelectTotal = res.data.data.total || 0;
        this.goodsLevelFirstList = res.data.data.goods_level || [];
      }
      this.goodsSelectLoading = false;
    },

    handleTypeChange(val) {
      this.goodsSelectSearch.level_id = "";
      this.goodsLevelSecondList = [];
      const target = this.goodsLevelFirstList.find((i) => i.type == val);
      if (target) this.goodsLevelSecondList = target.goods_level || [];
    },

    resetGoodsSelectSearch() {
      this.goodsSelectSearch = {
        page: 1,
        page_size: 10,
        title: "",
        type: "",
        level_id: "",
        flag: 11,
      };
      this.goodsSelectType = "";
      this.goodsLevelSecondList = [];
      this.selectedGoodsList = [];
    },

    // 整行点击选择
    handleRowSelect(row) {
      this.$refs.goodsTableRef.toggleRowSelection(row);
    },
    handleSelectionChange(val) {
      this.selectedGoodsList = val;
    },

    // 确认选择 → 放入暂存表格
    // 确认选择赏品（完整版，修复选中无效问题）
    confirmSelectGoods() {
      // 关键：用 this.$refs 拿选中行，不要用变量
      const selected = this.$refs.goodsTableRef.selection;

      if (!selected || selected.length == 0) {
        this.$message.warning("请选择赏品");
        return;
      }

      selected.forEach((item) => {
        // 真实赏品去重
        if (item.goods_type == 1) {
          const exist = this.tempGoodsList.some((i) => i.id == item.id);
          if (exist) return;
        }

        this.tempGoodsList.push({
          ...item,
          num: 1,
          level_id: "",
          recovery_price: item.price || 0,
        });
      });

      // 清空选择
      this.$refs.goodsTableRef.clearSelection();
      this.goodsSelectVisible = false;
    },

    // 删除暂存
    delTempGoods(index) {
      this.tempGoodsList.splice(index, 1);
    },

    // 提交暂存 → 调用真实添加接口
    async submitTempGoods() {
      if (this.tempGoodsList.length == 0) {
        return this.$message.warning("暂无暂存数据");
      }

      const prize_info = this.tempGoodsList.map((item) => ({
        goods_id: item.id,
        title: item.title,
        image: item.image,
        price: item.price,
        recovery_price: item.recovery_price,
        origin_num: item.num,
        level_id: item.level_id,
        goods_type: item.goods_type,
      }));

      const res = await api.rechargeWealRoom.addBoxPrize({
        room_id: this.currentLuck.id,
        prize_info: JSON.stringify(prize_info),
      });

      if (res.data.code == 1000) {
        this.tempGoodsList = []; // 提交后清空
        this.getGoodsList();
      }
    },

    // 图片
    // 图片列表
    async getImageList() {
      this.imageLoading = true;
      const res = await api.images.index({ params: this.imageSearch });
      if (res.data.code == 1000) {
        this.imageList = res.data.data.data || [];
        this.imageTotal = res.data.data.total || 0;
        // 自动加载图片类型下拉框（你接口返回的 image_type）
        this.imageTypeList = res.data.data.image_type || [];
      }
      this.imageLoading = false;
    },
    selectImage(img) {
      this.selectedImageId = img.id;
      this.selectedImageUrl = img.url;
    },
    confirmSelectImage() {
      this.form.image = this.selectedImageUrl;
      this.mobileEditForm.image = this.selectedImageUrl;
      this.imageDialogVisible = false;
    },

    resetForm() {
      this.form = { room_id: "", name: "", image: "", num: "" };
    },
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        name: "",
        status: "",
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
    handleGoodsSizeChange(val) {
      this.goodsSearch.page_size = val;
      this.getGoodsList();
    },
    handleGoodsCurrentChange(val) {
      this.goodsSearch.page = val;
      this.getGoodsList();
    },
    handleGoodsSelectSizeChange(val) {
      this.goodsSelectSearch.page_size = val;
      this.getGoodsSelectList();
    },
    handleGoodsSelectCurrentChange(val) {
      this.goodsSelectSearch.page = val;
      this.getGoodsSelectList();
    },
    handleImageSizeChange(val) {
      this.imageSearch.page_size = val;
      this.getImageList();
    },
    handleImageCurrentChange(val) {
      this.imageSearch.page = val;
      this.getImageList();
    },
    resetImageSearch() {
      this.imageSearch = { page: 1, page_size: 10, name: "", type: "" };
      this.getImageList();
    },
    handleRowClick(row) {
      this.detailData = row;
      this.detailVisible = true;
    },
    // 打开中奖列表
    handleHitList(row) {
      this.hitSearch.room_id = row.id;
      this.resetHitSearch();
      this.hitVisible = true;
    },
    // 打开抽奖码编辑赏品弹窗
    async openCodePrizeDialog(row) {
      this.currentCodeId = row.id;
      this.selectedCodePrize = null;
      this.selectedPrizeId = null;
      this.codePrizeVisible = true;

      const res = await api.rechargeWealRoom.getPrizeList({
        room_id: row.room_id,
      });
      if (res.data.code == "1000") {
        this.codePrizeList = this.addUuid(res.data.data) || [];
      }
    },
    // 给数组每一项加唯一 uuid
    addUuid(arr) {
      if (!Array.isArray(arr)) return arr;
      return arr.map((item, index) => {
        return {
          ...item,
          uuid: index + 1, // 用索引+1作为唯一标识（从1开始）
        };
      });
    },
    // 单选选中
    handleSelectCodePrize(row) {
      this.selectedCodePrize = row;
    },

    // 确认提交
    async confirmCodePrize() {
      console.log(this.currentCodeId, this.selectedCodePrize.id);
      if (!this.selectedCodePrize) {
        this.$message.warning("请选择一个赏品");
        return;
      }
      const res = await api.rechargeWealRoom.sysPrize({
        code_id: this.currentCodeId,
        prize_id: this.selectedCodePrize.id,
      });
      if (res.data.code == "1000") {
        this.codePrizeVisible = false;
        this.getCodeList();
      }
    },
    // 获取中奖列表
    async getHitList() {
      this.hitLoading = true;
      const res = await api.rechargeWealRoom.luckDrawsHitPrizeDetail({
        params: this.hitSearch,
      });
      if (res.data.code == 1000) {
        this.hitList = res.data.data.data || [];
        this.hitTotal = res.data.data.total || 0;
      }
      this.hitLoading = false;
    },

    // 重置中奖搜索
    resetHitSearch() {
      this.hitSearch = {
        page: 1,
        page_size: 10,
        room_id: this.hitSearch.room_id,
        user_id: "",
      };
      this.getHitList();
    },

    // 中奖分页
    handleHitSizeChange(val) {
      this.hitSearch.page_size = val;
      this.getHitList();
    },
    handleHitCurrentChange(val) {
      this.hitSearch.page = val;
      this.getHitList();
    },

    // ==================== 移动端中奖列表 ====================
    openMobileHitList(row) {
      this.hitSearchMobile.room_id = row.id;
      this.resetMobileHitSearch();
    },
    async getMobileHitList() {
      this.hitLoadingMobile = true;
      const res = await api.rechargeWealRoom.luckDrawsHitPrizeDetail({
        params: this.hitSearchMobile,
      });
      if (res.data.code == 1000) {
        this.hitListMobile = res.data.data.data || [];
        this.hitTotalMobile = res.data.data.total || 0;
      }
      this.hitLoadingMobile = false;
      this.mobileHitVisible = true;
    },
    resetMobileHitSearch() {
      this.hitSearchMobile = {
        page: 1,
        page_size: 10,
        room_id: this.hitSearchMobile.room_id,
        user_id: "",
      };
      this.getMobileHitList();
    },
    handleMobileHitSizeChange(val) {
      this.hitSearchMobile.page_size = val;
      this.getMobileHitList();
    },
    handleMobileHitCurrentChange(val) {
      this.hitSearchMobile.page = val;
      this.getMobileHitList();
    },

    // ==================== 移动端抽奖码编辑赏品 ====================
    async openMobileCodePrize(row) {
      this.currentCodeIdMobile = row.id;
      this.selectedPrizeId = null;
      this.codePrizeLoadingMobile = true;
      this.mobileCodePrizeVisible = true;

      const res = await api.rechargeWealRoom.getPrizeList({ room_id: row.room_id });
      if (res.data.code == "1000") {
        this.codePrizeListMobile = this.addUuid(res.data.data);
      }
      this.codePrizeLoadingMobile = false;
    },
    selectMobilePrize(row) {
      this.selectedPrizeId = row.uuid;
      this.selectedCodePrize = row;
    },
    async confirmMobileCodePrize() {
      if (!this.selectedCodePrize) {
        return this.$message.warning("请选择赏品");
      }
      const res = await api.rechargeWealRoom.sysPrize({
        code_id: this.currentCodeIdMobile,
        prize_id: this.selectedCodePrize.id,
      });
      if (res.data.code == "1000") {
        this.mobileCodePrizeVisible = false;
        this.getMobileCodeList();
      }
    },
    // 移动端 上架/下架 开关切换
    async handleMobileSwitchChange(row) {
      const oldStatus = row.status === 1 ? 0 : 1;
      const newStatus = row.status;
      try {
        const res = await api.rechargeWealRoom.status({
          room_id: row.id,
          status: newStatus,
        });
        this.getList()
        if (res.data.code !== 1000) {
          // 接口失败回滚状态
          row.status = oldStatus;
        }
      } catch (err) {
        // 请求异常回滚状态
        row.status = oldStatus;
      }
    },
  },
};
</script>

<style scoped>
/* ====================== PC 原有样式 ====================== */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 20px;
  align-items: center;
}
.detail-box {
  font-size: 14px;
  line-height: 2;
}

/* ====================== 移动端样式 ====================== */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.card-img {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  object-fit: cover;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.status {
  font-size: 12px;
  padding: 3px 6px;
  border-radius: 4px;
}
.status.on {
  background: #e6f7ff;
  color: #409eff;
}
.status.waiting {
  background: #f5f5f5;
  color: #909399;
}
.status.off {
  background: #fff0f0;
  color: #f56c6c;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

/* 移动端抽奖码卡片 */
.mobile-code-search {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.search-row {
  display: flex;
  gap: 8px;
}
.search-btn-row {
  display: flex;
  gap: 8px;
}
.mobile-code-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 4px;
}
.code-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.04);
  border-left: 4px solid #409eff;
}
.code-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.code-number {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  letter-spacing: 1px;
}
.code-number.used {
  color: #999;
  text-decoration: line-through;
}
.code-number.draw {
  color: #ff6b35;
}
.code-badges {
  display: flex;
  gap: 4px;
}
.badge {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}
.badge-unuse {
  background: #e6f7ff;
  color: #409eff;
}
.badge-used {
  background: #f5f5f5;
  color: #999;
}
.badge-draw {
  background: #fff7e6;
  color: #ff6b35;
}
.badge-nodraw {
  background: #f0f9ff;
  color: #409eff;
}
.code-info {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
}
.empty {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 14px;
}
.code-copy-btn {
  margin-top: 8px;
  text-align: right;
  color: #409eff;
  font-size: 12px;
  cursor: pointer;
}

/* 移动端中奖列表 */
.mobile-hit-search {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-hit-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 60vh;
  overflow-y: auto;
}
.hit-card {
  background: #fff;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  border-left: 4px solid #ff6b35;
}
.hit-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.hit-user {
  display: flex;
  align-items: center;
  gap: 8px;
}
.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}
.hit-user .info {
  line-height: 1.3;
}
.hit-user .nickname {
  font-size: 14px;
  font-weight: 500;
}
.hit-user .uid {
  font-size: 12px;
  color: #999;
}
.hit-code {
  font-size: 13px;
  color: #409eff;
  font-weight: bold;
}
.hit-goods {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 8px 0;
}
.goods-img {
  width: 46px;
  height: 46px;
  border-radius: 6px;
  object-fit: cover;
}
.goods-info {
  flex: 1;
  line-height: 1.4;
}
.goods-name {
  font-size: 14px;
}
.price {
  font-size: 12px;
  color: #f56c6c;
}
.hit-time {
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  margin-top: 4px;
}

/* 抽奖码编辑按钮 */
.code-edit-btn {
  margin-top: 6px;
  text-align: right;
  color: #f7ba1b;
  font-size: 12px;
  cursor: pointer;
}

/* 移动端赏品选择列表 */
.mobile-prize-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 50vh;
  overflow-y: auto;
}
.prize-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #eee;
  cursor: pointer;
}
.prize-item.active {
  border-color: #409eff;
  background: #e6f7ff;
}
.prize-img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 6px;
}
.prize-info {
  flex: 1;
  line-height: 1.4;
}
.prize-info .name {
  font-size: 14px;
  font-weight: 500;
}
.prize-info .level,
.prize-info .price {
  font-size: 12px;
  color: #666;
}
/* 移动端状态+开关布局 */
.status-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
</style>



// WEBPACK FOOTER //
// src/pages/rechargeWealRoom/index.vue